export type PublicApkRelease = {
  version: string;
  versionName: string;
  versionCode: number;
  sha256: string;
  sizeBytes: number;
  publishedAt: string;
  url: string;
  commit: string;
};

const publicDownloadOrigin = 'https://downloads.obby.ca';
const publicApkPath = '/releases/jellyflix-public-android-release.apk';

export function parsePublicApkRelease(value: unknown): PublicApkRelease | null {
  if (!value || typeof value !== 'object') return null;
  const release = value as Partial<PublicApkRelease>;
  if (
    typeof release.version !== 'string'
    || typeof release.versionName !== 'string'
    || !Number.isInteger(release.versionCode)
    || (release.versionCode ?? 0) <= 0
    || typeof release.sha256 !== 'string'
    || !/^[a-f0-9]{64}$/i.test(release.sha256)
    || !Number.isInteger(release.sizeBytes)
    || (release.sizeBytes ?? 0) <= 0
    || typeof release.publishedAt !== 'string'
    || typeof release.url !== 'string'
    || typeof release.commit !== 'string'
  ) return null;

  try {
    const url = new URL(release.url);
    if (url.origin !== publicDownloadOrigin || url.pathname !== publicApkPath) return null;
  } catch {
    return null;
  }

  return release as PublicApkRelease;
}

export function isPublicApkUpdateAvailable(currentVersionCode: number, release: PublicApkRelease) {
  return Number.isInteger(currentVersionCode)
    && currentVersionCode > 0
    && release.versionCode > currentVersionCode;
}

export function publicApkChecksumUrl(release: PublicApkRelease) {
  return `${release.url}.sha256`;
}

export function doesPublicApkChecksumMatch(release: PublicApkRelease, checksumDocument: string) {
  const [publishedHash = ''] = checksumDocument.trim().split(/\s+/, 1);
  return publishedHash.toLowerCase() === release.sha256.toLowerCase();
}
